import { Box, Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Vendas } from './components/Vendas';

export function VendasPedido({ infoCustomer, codCustomerSelected }) {
  return (
    <Flex display="flex" gap={3} alignItems="center" justifyContent="space-between" w="100%">
      <Text color="#FFA200" fontSize="18px" fontWeight="semibold" textTransform="uppercase">
        Total:{' '}
        <Text as="span" color="#2D2D2D">
          {infoCustomer?.vendas_mes}
        </Text>
      </Text>
      <Box height="20px" width="3px" bgColor="#FFA200" />
      <Vendas title="Vendas da Semana" valor={infoCustomer?.vendas_semana} lineColor="#FFA200" />

      <Text color="#FFA200" fontSize="18px" fontWeight="semibold" textTransform="uppercase">
        Pedidos:{' '}
        <Text
          as={Link}
          color="#2D2D2D"
          to={`/propostas/${codCustomerSelected}?pedidos_mes=${infoCustomer?.pedidos_mes}`}>
          {infoCustomer?.pedidos_mes}
        </Text>
      </Text>
      <Box height="20px" width="3px" bgColor="#FFA200" />
      <Vendas title="Pedidos da Semana" valor={infoCustomer?.pedidos_semana} lineColor="#FFA200" />
    </Flex>
  );
}
